import { createGlobalStyle } from 'styled-components';

export const CustomStyles = createGlobalStyle`
  .custom-map .leaflet-popup-content-wrapper {
    border-radius: 0;
  }
  .leaflet-marker-icon,
  .leaflet-div-icon {
    border: 0 !important;
    background: none !important;
  }
  .swiper-slide {
    height: 100%;
    display: flex;
    align-items: center;
    width: 70%;
  }
  .swiper-wrapper {
    align-items: center;
  }
`;
